import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="treegrid"
export default class extends Controller {
	/** @returns {import("./treegrid/row_controller").default[]} */
	get rows() {
		return Array.from(this.element.querySelectorAll(
			`[data-controller="treegrid--row"]:not([hidden])`
		)).map(element => this.application.getControllerForElementAndIdentifier(
			element, "treegrid--row"
		))
	}

	get firstRow() {
		return this.rows[0]
	}

	get lastRow() {
		const rows = this.rows

		return this.rows[rows.length - 1]
	}
}
